import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { useLocalize } from '@treams/treams-hooks';
import { CareerPartialFragment } from '@treams/treams-network';
import { Breakpoint, Heading3, Paragraph, QuillText, tokens } from '@treams/treams-ui';

import JobTitleButtonTimeline from './JobTitleButtonTimeline';

const HeaderContainer = styled(Flex)`
	padding-bottom: ${tokens.gap.section}px;

	@media screen and (max-width: ${Breakpoint.Medium}) {
		flex-direction: column;
	}

	@media screen and (min-width: ${Breakpoint.Medium}) {
		flex-direction: row;
		gap: ${tokens.gap.section}px;
	}
`;

type CareerJobTitle = CareerPartialFragment['jobTitles'][number];

type Props = {
	career: CareerPartialFragment;
	linkedJobTitle?: CareerJobTitle;
};

const CareerDetailHeader: FC<Props> = ({ career, linkedJobTitle }) => {
	const { localize } = useLocalize();
	const { t } = useTranslation();
	const [selectedJobTitle, setSelectedJobTitle] = useState<CareerJobTitle | undefined>(undefined);

	return (
		<HeaderContainer>
			<Box flex={1}>
				<JobTitleButtonTimeline
					career={career}
					linkedJobTitle={linkedJobTitle}
					onClick={(selectedJobTitle) => setSelectedJobTitle(selectedJobTitle)}
				/>
			</Box>
			<Box pb={selectedJobTitle?.description ? 4 : 0} flex={2}>
				<Heading3 mb={`${tokens.gap.list}px`}>{t('career.detail.header.title')}</Heading3>
				{selectedJobTitle && selectedJobTitle.description && (
					<Paragraph>
						<QuillText value={localize(selectedJobTitle?.description ?? []).text}></QuillText>
					</Paragraph>
				)}
			</Box>
		</HeaderContainer>
	);
};

export default CareerDetailHeader;
